import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
import {CommonsService} from "@core/service/commons.service";

@Component({
  selector: 'app-price-reduciton',
  templateUrl: './price-reduciton.component.html',
  styles: []
})
export class PriceReducitonComponent implements OnInit {
  @Input() readonly; //是否只读
  @Input() priceReductionVisible;//modal框是否显示
  @Input() priceReductionList;//年度降价列表
  @Output() private modalOk = new EventEmitter();
  @Output() private modalCancel = new EventEmitter();
  constructor(private commonsService:CommonsService) { }
  priceReductionCancel(){
    this.modalCancel.emit();
  }
  priceReductionOk(){
    for(let i=0;i<this.priceReductionList.length;i++){
      if(!this.priceReductionList[i].year || !this.priceReductionList[i].rate){
        this.commonsService.showWarningMessage('msg.warning.addInformation');
        return;
      }
    }
    this.modalOk.emit(this.priceReductionList);
  }

  addPriceReductionList(){
    if(!this.priceReductionList){
      this.priceReductionList = [];
    }
    this.priceReductionList.push({});
  }

  deletePriceReductionList(){
    let list = [];
    for(let i=0;i<this.priceReductionList.length;i++){
      if(!this.priceReductionList[i].checked){
        list.push(this.priceReductionList[i]);
      }
    }
    this.priceReductionList = list;
  }

  ngOnInit() {
  }

}
